import { WithStyles, withStyles } from '@mui/styles';
import { AgGridColumnDef } from '@tassat/common-definitions';
import React from 'react';

import { SideListGridOptions } from 'SharedComponents/sideList';

import { GridSettingsContext } from './../sideListLayout/gridSettingsContext';
import { SideListComponent } from './sideListComponent';
import { muiStyles } from './styles';
import { SidelistLayoutFormOptions } from '../sideListLayout';

export interface ISideListLayoutProps extends WithStyles<typeof muiStyles> {
    children?: React.ReactNode;
    rowData: any[];
    columnDefs: AgGridColumnDef[];
    gridOptions: SideListGridOptions;
    formOptions?: SidelistLayoutFormOptions;
}

export default withStyles(muiStyles)(SideListComponent);
export { GridSettingsContext };